/** @format */

import React from 'react';
import { PageContainer } from 'components';
import { CommonProvider } from 'providers';
import { useNavigate } from 'react-router-dom';
import { Content } from './components';
import { constBreadCrumbsTitle } from 'utility';

const WalletAndGuild = () => {
  const hint = 'در این بخش می‌توانید گزارش تلفیقی را مشاهده نمایید.';
  return (
    <>
      <PageContainer
        title="گزارش تلفیقی"
        pageKey="WalletAndGuild"
        description={hint}
        breadcrumbs={constBreadCrumbsTitle.WALLETANDGUILD}
        toolTipText="گزارش جاری با تاخیر 24 ساعته نمایش داده می شود."
      >
        <CommonProvider>
          <Content />
        </CommonProvider>
      </PageContainer>
    </>
  );
};

export default WalletAndGuild;
